

import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";




import {
  
  BsUiRadiosGrid,
  BsHouseDoor,
  BsNut,
  BsNewspaper,
  BsListNested,
  BsPatchQuestion,
  BsTelephonePlus,
  BsChevronDown,
  BsGear,
} from "react-icons/bs";

import "../css/nav.css";


const iconMapping = {
    BsHouseDoor: <BsHouseDoor />,
    BsNut: <BsNut />,
    BsNewspaper: <BsNewspaper />,
    BsListNested: <BsListNested />,
    BsPatchQuestion: <BsPatchQuestion />,
    BsTelephonePlus: <BsTelephonePlus />,
    BsGear: <BsGear />,
  };
const NavMenu=()=>{

  
    // Access the navigation state from Redux
    const {  menu } = useSelector((state) => state.navigation);


    return(
        <>
          {menu.map((menuItem, index) => {
                if (menuItem.items) {
                  return (
                    <NavDropdown
                      className="catagory-block"
                      title={
                        <>
                          {<BsUiRadiosGrid />} {menuItem.name} {<BsChevronDown />}
                        </>
                      }
                      id={`navbarScrollingDropdown${index}`}
                      key={index}
                    >
                      {menuItem.items.map((subItem, subIndex) => {
                        if (subItem.items) {
                          // If the subItem has further nested items, create another NavDropdown
                          return (
                            <NavDropdown className="navbafsd"
                              title={subItem.name}
                              id={`navbarScrollingDropdown${index}-${subIndex}`}
                              key={subIndex}
                            >
                              {subItem.items.map((nestedItem, nestedIndex) => (
                                <NavDropdown.Item 
                                  href={nestedItem.linkmenus}
                                  key={nestedIndex}
                                >
                                  {nestedItem.name}
                                </NavDropdown.Item>
                              ))}
                            </NavDropdown>
                          );
                        }
                        return (
                          <NavDropdown.Item 
                            href={subItem.linkmenus}
                            key={subIndex}
                          >
                            {subItem.name}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                  );
                }
                return (
                  <Nav.Link href={menuItem.linkmenus} key={index}>
                    {menuItem.icon && iconMapping[menuItem.icon]} {menuItem.name}
                  </Nav.Link>
                );
              })}
        </>
    )


}


export default NavMenu